// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 884 ? "admin" : chunkId) + "." + {"539":"25c3ee3a","628":"2b0348bb","807":"cd19c99e","884":"d674db28"}[chunkId] + ".css";
};